// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d7689d0b","455":"a5a97045","977":"061f1ef1"}[chunkId] + ".chunk.js";
};